import { render, staticRenderFns } from "./HeaderBox.vue?vue&type=template&id=70a3dba5&scoped=true&"
import script from "./HeaderBox.vue?vue&type=script&lang=js&"
export * from "./HeaderBox.vue?vue&type=script&lang=js&"
import style0 from "./HeaderBox.vue?vue&type=style&index=0&id=70a3dba5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70a3dba5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
